var moment = require('moment')
var Column = require('./column')

module.exports = Column.extend({
    format: function(value) {
        return value ? moment(value).format('LL') : ''
    }
})
